import React from "react";
import PropTypes from "prop-types";
import Typography from "./ui/Typography";

const TrustPageIntro = ({
  eyebrow,
  title,
  description,
  actions = null,
  footer = null,
}) => (
  <section className="trust-page-intro">
    <div className="trust-page-intro__copy">
      {eyebrow ? (
        <Typography variant="caption" className="text-primary">
          {eyebrow}
        </Typography>
      ) : null}
      <Typography variant="h1" className="text-foreground">
        {title}
      </Typography>
      <Typography variant="body-large" className="text-foreground/85 sm:text-body">
        {description}
      </Typography>
    </div>

    {actions ? <div className="trust-page-intro__actions">{actions}</div> : null}
    {footer}
  </section>
);

TrustPageIntro.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  actions: PropTypes.node,
  footer: PropTypes.node,
};

export default TrustPageIntro;
